let moment = require('moment');

class OrderItemInformation {

  constructor(obj = {}) {
    Object.assign(this, obj);
  }

  product = null;

  _quantity = '';

  get quantity()
  {
    let value = Number(this._quantity);
    value = value || 1;
    value = Math.abs(value);
    value = Math.trunc(value);

    return value;
  }

  set quantity(value)
  {
    this._quantity = value;
  }

  _fechaEntrega = null;
  get fecha_entrega()
  {
    if (!!this._fechaEntrega)
    {
      return moment(this._fechaEntrega).format('YYYY-MM-DD')
    }
    return null;
  }

  get fecha_entrega_usuario()
  {
    if (!!this._fechaEntrega)
    {
      return moment(this._fechaEntrega).format('DD-MM-YYYY');
    }
    return null;
  }

  toJSON()
  {
    return {
      ...this,
      fechaEntrega: this.fecha_entrega,
      quantity: this.quantity
    }
  }

  get subtotal()
  {
    if (!!this.product)
    {
      return this.quantity * this.product.importe;
    }

    return 0;
  }
}

module.exports = OrderItemInformation;
